export function dscParseCPS(text) {
  const lines = text.split(/\r?\n/);

  const index = lines.findIndex((line) => line.match(/^[ ,]*$/));

  return {
    meta: parseMeta(lines.slice(0, index)),
    data: parseData(lines.slice(index + 1)),
  };
}

function parseMeta(lines) {
  let meta = {};
  for (let line of lines) {
    const field = line.split(',').find(Boolean);
    if (field.includes(':')) {
      meta[field.replace(/:.*/, '').trim()] = field.replace(/.*?:/, '').trim();
    }
  }
  return meta;
}

function parseData(lines) {
  const columns = [];
  for (let line of lines) {
    let fields = line.split(/,/);
    if (fields.length < 10) continue;
    for (let i = 0; i < fields.length; i++) {
      let value = fields[i].trim();
      let number = Number.parseFloat(value);
      if (!columns[i]) columns[i] = [];
      columns[i].push(Number.isNaN(number) ? value : number);
    }
  }

  const data = {};
  for (let i = 0; i < columns.length; i++) {
    let column = columns[i];

    if (column.filter(Boolean).length === 0) continue;
    let target = '';
    if ([4, 5, 6].includes(i)) target = columns[5][0];
    if ([8, 9, 10].includes(i)) target = columns[9][0];
    if ([12, 13, 14].includes(i)) target = columns[13][0];
    if ([16, 17, 18].includes(i)) target = columns[17][0];
    if (target) {
      if (!data[target]) data[target] = {};
      appendVariable(data[target], columns[i], target);
    } else {
      appendVariable(data, columns[i]);
    }
  }
  return data;
}

function appendVariable(object, column, target = '') {
  object[column[1]] = {
    units: column[2],
    label: target ? `${target} ${column[1]}` : column[1],
    data: column.slice(3),
  };
}
